<template>
  <v-menu
    ref="refMenu"
    offset-y
    eagers
    attach
    class="horizontal-nav-header-group"
    content-class="list-style elevation-0"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        depressed
        large
        style="
          font-size: 13px !important;
          min-width: 170px;
          max-width: 170px;
          border-left: 1px solid #e3e1e1 !important;
          border-right: 1px solid #e3e1e1 !important;
        "
        tile
        color="transparent"
        dark
        v-bind="attrs"
        class="text-capitalize text-base px-5 mr-0 tab-button font-weight-medium text--primary"
        :class="[{ 'bg-tab-nav': isActive }, { 'menu-open': isMenuActive }]"
        v-on="on"
      >
        <span class="mr-3">{{ menuTabTitle ? menuTabTitle.attribute : 'Select' }}</span>
        <v-icon size="20">
          {{ icons.mdiChevronDown }}
        </v-icon>
      </v-btn>
    </template>
    <v-list ref="refContent" :elevation="$vuetify.theme.dark ? 9 : 8" class="primary white--text">
      <v-list-item-group>
        <component
          :is="resolveNavComponent(child)"
          v-for="child in item.children"
          :key="child.subheader || child.title"
          :item="child"
        ></component>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import HorizontalTabMenuLink from '@core/layouts/components/horizontal-tab-menu/components/HorizontalTabMenuLink.vue'
import { mdiChevronDown } from '@mdi/js'
import themeConfig from '@themeConfig'
import { computed, ref, watchEffect } from '@vue/composition-api'
import useTabMenuHeaderGroup from '@core/layouts/components/horizontal-tab-menu/components/horizontal-tab-menu-header-group/useTabMenuHeaderGroup'
import store from '@/store'

export default {
  components: {
    HorizontalTabMenuLink,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    // eslint-disable-next-line object-curly-newline
    const { isActive, updateIsActive, isOpen, updateGroupOpen } = useTabMenuHeaderGroup(props.item)

    const resolveNavComponent = item => {
      if (item.children) return 'horizontal-nav-menu-group'

      return 'horizontal-tab-menu-link'
    }

    // Templare ref & internal value
    const refMenu = ref(null)
    const isMenuActive = ref(false)
    watchEffect(() => {
      isMenuActive.value = refMenu.value ? refMenu.value.isActive : false
    })
    const menuTabTitle = computed(() => store.getters['tabPersist/getPersistTab'])

    return {
      menuTabTitle,
      isOpen,
      isActive,
      updateGroupOpen,
      updateIsActive,

      resolveNavComponent,

      // Open Menu on Hover
      shallOpenGroupOnHover: themeConfig.menu.horizontalNavMenuGroupOpenOnHover,

      // Template Ref and internal Properties
      refMenu,
      isMenuActive,

      // icons
      icons: {
        mdiChevronDown,
      },
    }
  },
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';
@import '~@core/preset/preset/mixins.scss';

@include theme(horizontal-nav-menu) using ($material) {
  // ! Below style will also affect HorizontalNavGroup
  // ? If you only want this style of this component than use selector `> .menu-open` instead of `.menu-open`
  .menu-open {
    background: rgba(map-deep-get($shades, 'black'), map-deep-get($material, 'states', 'hover'));
  }
}

.horizontal-nav-menu {
  > .group-activator-active {
    box-shadow: 0 5px 10px -4px rgba(94, 86, 105, 0.42);
    @include elevationTransition();
  }
  .v-list-item__icon {
    align-self: center;
  }
  .v-list-item {
    min-height: 42px;
    max-height: 42px;
  }
}

.horizontal-nav-header-group {
  > .v-menu__content {
    padding-top: 13px;
  }

  .v-menu__content {
    // min-width: 260px;
    width: 260px;
    contain: none !important;
    overflow: visible !important;

    > .v-list {
      border-radius: 6px;
      // @include elevation(8);
    }
  }
}

@include app-elevation('horizontal-nav-header-group .v-menu__content > .v-list', 8);
</style>
